






























import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import ProfitLossTable from '@/components/ProfitLossTable.vue';
@Component({
  components: {ProfitLossTable},
})
export default class CardProfitLoss extends CompanyMixin {
 }
